import lazyPage from "../../../../../../common/helpers/lazyPage";

export default lazyPage(
    "src/front/components/Task/types/TonesetStaff/editor/tonesetstaffeditor.tsx",
    () => import("./tonesetstaffeditor"),
);
